import { Link } from 'react-router-dom';
import { rankings } from '@/mocks/comics';

export default function RankingSection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            人气排行
          </h2>
          <p className="text-sm text-foreground-500 mt-1">最受欢迎的韩漫作品排行榜</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden">
            {rankings.map((item, index) => (
              <Link
                key={item.rank}
                to={`/article/${item.comicSlug}`}
                className={`flex items-center gap-4 px-5 py-4 transition-colors hover:bg-background-100 cursor-pointer ${
                  index < rankings.length - 1 ? 'border-b border-background-200/60' : ''
                }`}
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-secondary-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-primary-400 text-background-50'
                    : 'bg-background-100 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1">{item.title}</h3>
                </div>

                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-eye-line text-xs"></i>
                  </div>
                  <span>{item.views >= 10000 ? `${(item.views / 10000).toFixed(0)}万` : item.views}</span>
                </div>

                <div className="w-6 h-6 flex items-center justify-center">
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-sm text-green-500"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line text-sm text-red-400"></i>}
                  {item.trend === 'new' && <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 text-xs">新</span>}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}